import { render } from "./MyRepos.vue?vue&type=template&id=5e6d19f3&ts=true"
import script from "./MyRepos.vue?vue&type=script&lang=ts"
export * from "./MyRepos.vue?vue&type=script&lang=ts"

import exportComponent from "/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__